import {
  EMPTY_BREADCRUMBS,
  SET_BREADCRUMBS,
  SET_ITEM_BREADCRUMBS
} from "../actions/action-types";
import { STEP_SEPARATOR } from "../utils/constants";

export const itemBreadcrumbsReducer = (state = {}, action) => {
  if (action.type === SET_ITEM_BREADCRUMBS) {
    const { textItem, stepItem } = action.itemBreadcrumbs;
    const crumbKey = `${stepItem.step}${STEP_SEPARATOR}${stepItem.subStep}`;
    const crumb = { [crumbKey]: textItem };
    return { ...state, ...crumb };
  }
  if (action.type === SET_BREADCRUMBS) {
    return action.breadcrumbs;
  }
  if (action.type === EMPTY_BREADCRUMBS) {
    return {};
  }
  return state;
};
